module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlave/Nagano_Chlave_HadGEM2_RCP26_End.png";